module.exports = __webpack_public_path__ + "img/device05.0aa06574.png";